export default __webpack_public_path__ + "static/media/sale3.510ae2a0.png";